import { getAPIwithToken } from '../utils/fetchApi'

export interface SystemStatusResponse {
  status: 'ok' | 'maintenance' | 'down'
  message?: string
  maintenance?: boolean
}

export const checkSystemStatus = async (): Promise<SystemStatusResponse> => {
  try {
    const data = await getAPIwithToken<SystemStatusResponse>('/system/status')
    return data
  } catch (error: any) {
    // If backend endpoint is unavailable or returns 503, catch and format response
    if (error?.message?.toLowerCase().includes('503') || error?.message?.toLowerCase().includes('maintenance')) {
      return {
        status: 'maintenance',
        maintenance: true,
        message: error.message || 'System is currently down for maintenance.',
      }
    }
    throw error
  }
}
